export const TASK_LIST = "TASK_LIST";
export const TASK_LIST_RES = "TASK_LIST_RES";
export const NEW_TASK = "NEW_TASK";
export const NEW_TASK_RES = "NEW_TASK_RES";
export const TASK_FILTER = "TASK_FILTER";
export const TASK_ROW_UPDATE = "TASK_ROW_UPDATE"
export const TASK_ROW_UPDATE_RES = "TASK_ROW_UPDATE_RES"
export const TASK_BULK_UPDATE = "TASK_BULK_UPDATE"
export const TASK_BULK_UPDATE_RES = "TASK_BULK_UPDATE_RES"